import { render, staticRenderFns } from "./sideheader.vue?vue&type=template&id=761440b9&scoped=true&"
import script from "./sideheader.vue?vue&type=script&lang=js&"
export * from "./sideheader.vue?vue&type=script&lang=js&"
import style0 from "./sideheader.vue?vue&type=style&index=0&id=761440b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761440b9",
  null
  
)

export default component.exports